export default "__VITE_ASSET__cn3Px_A6__"